import { useEffect } from 'react';

export default () => {
  useEffect(() => {
    // NB: have to explicitely set this since we want to be outside
    // of the react router
    // We use replace instead of assign to avoid saving the bad history entry
    window.location.replace('/404');
  });

  return <div />;
};
